import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Creator } from '../models/creator';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Campaign } from '../models/campaign';

@Injectable({ providedIn: 'root' })
export class CreatorService {
  private creatorsCache: Creator[] = [];

  constructor(public http: HttpClient) { }

  getCreators(): Observable<Creator[]> {

    if (this.creatorsCache.length > 0) {
      return of(this.creatorsCache);
    }

    const url = `${environment.apiUrl}creators`;
    return this.http.get<Creator[]>(url).pipe(
      tap((creators) => {
        this.creatorsCache = creators;
      })
    );
  }

  getCampaigns(creatorId: string): Observable<Campaign[]> {
    const url = `${environment.apiUrl}creators/${creatorId}/campaigns`;
    return this.http.get<Campaign[]>(url);
  }

  addCreator(newCreator: Creator): Observable<Creator> {
    const url = `${environment.apiUrl}creators`;
    return this.http.post<Creator>(url, newCreator);
  }

  getCreator(id: string): Observable<Creator> {
    // should only be called if we already have this creator cached.
    const url = `${environment.apiUrl}creators/${id}`;
    return this.http.get<Creator>(url);
  }
}
